import styled from "@emotion/styled";
import { Heading } from "@otrium/atoms";
import { HyperLink } from "src/atoms/HyperLink";

const StyledProductCarouselInfoText = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    flex: 1;
    margin-right: ${({ theme }) => theme.space.space32};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-inline: var(--ot-gutter);
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    margin-right: ${({ theme }) => theme.space.space32};
  }
`;

const StyledTitle = styled(Heading)`
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  margin-bottom: ${({ theme }) => theme.space.space8};
  color: ${({ theme }) => theme.colors.tone.black};
  text-transform: none;
  font-family: "PlusJakartaSans";
  line-height: 1.33;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    font-size: ${({ theme }) => theme.fontSizes[3]}px;
    line-height: 1.25;
  }
`;

const StyledSubtitle = styled(Heading)`
  text-transform: unset;
`;

const StyledLink = styled(HyperLink)`
  flex-direction: row-reverse;
  justify-content: flex-end;
  font-family: "CharisSILW";

  svg {
    margin-top: 6px;
    margin-left: ${({ theme }) => theme.space.space8};
    fill: none;
  }

  div {
    font-size: ${({ theme }) => theme.fontSizes[1]}px;
    font-weight: 600;
    display: flex;
    margin-right: 0;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    align-items: center;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    div {
      margin-right: auto;
    }
  }
`;

export {
  StyledProductCarouselInfoText,
  StyledTitle,
  StyledLink,
  StyledSubtitle,
};
